






















































































import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
import HttpClient from "@/API/HttpClient";
import Utils from "@/store/utils";
import { setCookie, getCookie, delCookie } from "@/JS/cookie"; //使用getCookie方法
import httpApi from "@/API/Tenant/Weixin";
@Component({
  components: {}
})
export default class extends Vue {
  @Prop() private WxQrCodePosterList!: any;
  @Prop() private WxQrCodePosterDetail!: any;
  @Prop() private page!: any;
  @Provide() content: any = "";
  @Provide() activeName: any = "first";
  @Provide() dataList: any = [];
  @Provide() currentPage: number = 1;
  @Provide() pagesize: number = 10;
  @Provide() loading: boolean = false;
  @Provide() total: number = 0;
  @Provide() type: any = "1";
  async created() {
    if (this.WxQrCodePosterDetail.NickName) {
      this.content =
        this.WxQrCodePosterList.EventName +
        "——" +
        this.WxQrCodePosterDetail.NickName +
        "(" +
        this.WxQrCodePosterDetail.SceneId +
        ")";
    } else {
      this.content =
        this.WxQrCodePosterList.EventName +
        "——" +
        this.WxQrCodePosterDetail.SceneId +
        "";
    }
    if (this.activeName == "second") {
      this.dataList = [];
      this.wxFansList();
    } else {
      this.dataList = [];
      this.GetQrCodePosterStatistical();
    }
  }
  //返回
  back() {
    this.page.aid = this.WxQrCodePosterList.Aid;
    this.$emit("formData", {
      pagename: "viewForm",
      WxQrCodePosterList: this.WxQrCodePosterList,
      WxQrCodePosterDetail: this.WxQrCodePosterDetail,
      page: this.page
    });
  }
  //切换选项卡
  handleClick(tab: any, event: any) {
    console.log(tab.name);
    if (this.activeName == "second") {
      this.dataList = [];
      this.wxFansList();
    } else {
      this.dataList = [];
      this.GetQrCodePosterStatistical();
    }
  }
  //分页方法

  private handleSizeChange(val: any) {
    this.pagesize = val;
    if (this.activeName == "second") {
      this.dataList = [];
      this.wxFansList();
    } else {
      this.dataList = [];
      this.GetQrCodePosterStatistical();
    }
  }
  private handleCurrentChange(val: any) {
    this.currentPage = val;
    if (this.activeName == "second") {
      this.dataList = [];
      this.wxFansList();
    } else {
      this.dataList = [];
      this.GetQrCodePosterStatistical();
    }
  }
  //查询粉丝数据列表
  async wxFansList() {
    let params: any = {
      Input: [
        {
          Name: "model",
          value: {
            Aid: this.WxQrCodePosterList.Aid,
            FatherId: this.WxQrCodePosterDetail.SceneId
          }
        },
        {
          Name: "page",
          value: { page: this.currentPage, rows: this.pagesize }
        }
      ]
    };
    this.loading = true;
    var res: any = await httpApi.GetQrCodePosterDetaila(params);
    this.loading = false;
    //console.log(res);
    if (res.ErrorCode == 0) {
      this.dataList = res.output[0].value;
      this.total = res.output[1].value;
      console.log(this.dataList);
    } else {
      this.$message.error("读取粉丝详细数据失败：" + res.ErrorMessage);
    }
  }
  //查询每日数据
  async GetQrCodePosterStatistical() {
    console.log(this.WxQrCodePosterDetail);

    let params: any = {
      Input: [
        {
          Name: "model",
          value: {
            Aid: this.WxQrCodePosterList.Aid,
            PosterId: this.WxQrCodePosterDetail.PosterId,
            SceneId: this.WxQrCodePosterDetail.SceneId,
            Type: this.type
            //SceneId:this.WxQrCodePosterDetail.
          }
        },
        {
          Name: "page",
          value: { page: this.currentPage, rows: this.pagesize }
        }
      ]
    };
    console.log(params);

    this.loading = true;
    var res: any = await httpApi.GetQrCodePosterStatistical(params);
    this.loading = false;
    console.log(res);
    if (res.ErrorCode == 0) {
      this.dataList = res.output[0].value;
      this.total = res.output[1].value;
      console.log(this.dataList);
    } else {
      this.$message.error("读取每日详细数据失败：" + res.ErrorMessage);
    }
  }
}
